import { createContext } from "react";
const PlacementsContext = createContext();
export default PlacementsContext;